/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/comps/PlaceholderImage.tsx
 * @Description: 大小确定的带占位图的图片组件
 */
// @ts-ignore
import NoPic from 'images/cscec3b/no-pic';
// @ts-ignore
import NoPicW from 'images/cscec3b/no-picw';
import { DeviceContext, RuntimeConfigurationContext } from 'libs/contexts';
import { webps } from 'libs/imgs';
import { resizeImage } from 'libs/urls';
import { useContext } from 'react';
import { Image } from 'react-vant';

webps[NoPic] = NoPicW;

type ImgProp = React.PropsWithoutRef<JSX.IntrinsicElements['img']> & {
  styles?: any; // 图片样式
  height?: number | string; // 高度
  width?: number | string; // 宽度
  src?: string; // 图片地址
};

// TODO #PAZCSC-2400
/**
 * @description: 渲染函数
 * @param {ImgProp} param1
 */
export default function PlaceholderImage({ src, styles, height, width, ...rest }: ImgProp) {
  const { buildImgSrc } = useContext(DeviceContext);
  const rtCtx = useContext(RuntimeConfigurationContext);
  const ossProvider = rtCtx.find((item) => item.key === 'ossProvider')?.value ?? 'obs';
  const publicBucketName = rtCtx.find((config) => config.key === 'public-app-name')?.value;
  const privateBucketName = rtCtx.find((config) => config.key === 'private-app-name')?.value;
  const wzgjOssProvider = rtCtx.find((item) => item.key === 'wzgjOssProvider')?.value;
  const wzgjPublicOssProvider = rtCtx.find(
    (config) => config.key === 'wzgjPublicOssProvider',
  )?.value;

  let getSource: (orig: string) => string;
  // 如果是全路径图片
  if (
    src?.startsWith('http') &&
    !src?.includes('static-tg.tabe.cn') &&
    !src?.includes('static-tg.3jyx.cn') &&
    Number(width) > 0 &&
    Number(height) > 0
  ) {
    // 1. remote image
    // 2. known width & height
    getSource = (url) => {
      // > 0 => typeof 'number'
      return resizeImage(url, width as number, height as number, {
        ossProvider,
        publicBucketName,
        privateBucketName,
        wzgjOssProvider,
        wzgjPublicOssProvider,
      });
    };
  } else {
    // 图片优化
    getSource = buildImgSrc;
  }

  return (
    <Image
      src={getSource(src)}
      height={height}
      width={width}
      alt={rest.alt}
      style={{ display: 'inline-block' }}
      loadingIcon={<img src={buildImgSrc(NoPic)} height={height} width={width} alt="nopic" />}
      {...rest}
    />
  );
}
